var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9494_37921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 3.99983C8.66667 3.63164 8.36819 3.33317 8 3.33317C7.63181 3.33317 7.33333 3.63164 7.33333 3.99983V7.99983C7.33333 8.25235 7.476 8.48319 7.70186 8.59612L10.3685 9.92945C10.6978 10.0941 11.0983 9.96063 11.263 9.63131C11.4276 9.30199 11.2941 8.90154 10.9648 8.73688L8.66667 7.58781V3.99983Z",
    fill: "currentFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 0.666504C3.94993 0.666504 0.666687 3.94975 0.666687 7.99984C0.666687 12.0499 3.94993 15.3332 8.00002 15.3332C12.0501 15.3332 15.3334 12.0499 15.3334 7.99984C15.3334 3.94975 12.0501 0.666504 8.00002 0.666504ZM2.00002 7.99984C2.00002 4.68613 4.68631 1.99984 8.00002 1.99984C11.3137 1.99984 14 4.68613 14 7.99984C14 11.3135 11.3137 13.9998 8.00002 13.9998C4.68631 13.9998 2.00002 11.3135 2.00002 7.99984Z",
    fill: "currentFill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9494_37921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3c35df56.svg";
export { ForwardRef as ReactComponent };